import {
  ProductImpactContainer,
  ProductImpactContainerOuter,
  ProductImpactDiv,
  ProductImpactHeading,
} from './styled';

export default function index() {
  const productImpacts = [
    {
      icon: 'https://images.myloapp.in/NestJsUploads/1725966752813-PCOS.svg',
      text: 'PCOS, PCOD, or irregular periods',
    },
    {
      icon: 'https://images.myloapp.in/NestJsUploads/1725966752813-Poor-egg-quality-or-size.svg',
      text: 'Poor egg quality or size',
    },
    {
      icon: 'https://images.myloapp.in/NestJsUploads/1725966752812-Implantation.svg',
      text: 'Implantation failure or miscarriages',
    },
    {
      icon: 'https://images.myloapp.in/NestJsUploads/1725966752812-IUI-IVF.svg',
      text: 'IUI, IVF or other artificial treatments',
    },
    {
      icon: 'https://images.myloapp.in/NestJsUploads/1725966920713-AMH-issues.svg',
      text: 'AMH issues',
    },
    {
      icon: 'https://images.myloapp.in/NestJsUploads/1725966752809-Hormonal-imbalance.svg',
      text: 'Hormonal imbalance',
    },
  ];

  return (
    <ProductImpactContainerOuter>
      <ProductImpactHeading>Suitable for women with:</ProductImpactHeading>
      <ProductImpactContainer>
        {productImpacts.map((item, index) => (
          <ProductImpactDiv key={`product_impacts_${index}`}>
            <img src={item.icon} alt={item.text} />
            <p>{item.text}</p>
          </ProductImpactDiv>
        ))}
      </ProductImpactContainer>
    </ProductImpactContainerOuter>
  );
}
